module.exports = __webpack_public_path__ + "media/images/arrows/bullet-bf8404e7959e44e14010fe5ccafa58ea.svg";